import { Grid as SemanticGrid } from 'semantic-ui-react';

export { GridProps, StrictGridProps } from 'semantic-ui-react';

export const Grid: typeof SemanticGrid = SemanticGrid;

export default Grid;
